import {GLOBAL_CONSTANTS} from "../constants/global-constants";


const GLOBAL_ACTIONS = {

    setModalTypeAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_MODAL_TYPE,
            data,
        };
    },

    setModalTabAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_MODAL_TAB,
            data,
        };
    },

    setConfigurationAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_CONFIGURATION,
            data,
        };
    },

    setModalCurrencyAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_MODAL_CURRENCY,
            data,
        };
    },

    setNotificationsAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_NOTIFICATIONS,
            data,
        };
    },

    appendNotificationsAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.APPEND_NOTIFICATIONS,
            data,
        };
    },

    setGameProviders: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_GAME_PROVIDERS,
            data,
        };
    },
    setNetworks: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_NETWORKS,
            data,
        };
    },
    setInPlayAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_IN_PLAY,
            data,
        };
    },
    setSelectedCurrency: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_SELECTED_CURRENCY,
            data,
        };
    },
    setActiveLanguage: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_ACTIVE_LANGUAGE,
            data,
        };
    },
    setUserAgent: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_USER_AGENT,
            data,
        };
    },
    setSelectedCurrencyAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_SELECTED_CURRENCY,
            data,
        };
    },
    setThemeAction: (data) => {
        return {
            type: GLOBAL_CONSTANTS.SET_THEME,
            data,
        };
    },

    updateSharedState: (key, value) => ({
        type: 'UPDATE_SHARED_STATE',
        payload: {key, value}
    })
}


export default GLOBAL_ACTIONS
